import React, { useState } from "react";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Collapse,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  PersonAdd,
  People,
  ListAlt,
  Description,
  FolderOpen,
  BarChart,
  ShowChart,
  InsertDriveFile,
  Storage,
  FitnessCenter,
  CloudUpload,
} from "@mui/icons-material";

const drawerWidth = 260;

export default function AdminDrawer({
  selectedMenu,
  setSelectedMenu,
  userMgmtOpen,
  setUserMgmtOpen,
  analyticsOpen,
  setAnalyticsOpen,
  fileMgmtOpen,
  setFileMgmtOpen,
  modelMgmtOpen,
  setModelMgmtOpen,
}) {
  const handleUserMgmtClick = () => setUserMgmtOpen(!userMgmtOpen);
  const handleAnalyticsClick = () => setAnalyticsOpen(!analyticsOpen);
  const handleFileMgmtClick = () => setFileMgmtOpen(!fileMgmtOpen);
  const handleModelMgmtClick = () => setModelMgmtOpen(!modelMgmtOpen);

  const handleMenuSelect = (menu) => setSelectedMenu(menu);

  return (
    <Drawer
      variant="permanent"
      sx={{
        bgcolor: "#0B0D0E",
        width: drawerWidth,
        mt: 20,
        flexShrink: 0,
      }}
    >
      <Box sx={{ overflow: "auto", pt: 1, pb: 2, marginTop: 7 }}>
        <List component="nav" sx={{ px: 1 }}>
          {/* User Management */}
          <ListItemButton onClick={handleUserMgmtClick} sx={{ mb: 0.5 }}>
            <ListItemText
              primary="User Management"
              primaryTypographyProps={{ fontWeight: 700, fontSize: 15 }}
            />
            {userMgmtOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={userMgmtOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "createAccount"}
                onClick={() => handleMenuSelect("createAccount")}
              >
                <PersonAdd sx={{ mr: 1 }} />
                <ListItemText primary="Create Account" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "viewUsers"}
                onClick={() => handleMenuSelect("viewUsers")}
              >
                <People sx={{ mr: 1 }} />
                <ListItemText primary="View Users" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "userLogs"}
                onClick={() => handleMenuSelect("userLogs")}
              >
                <ListAlt sx={{ mr: 1 }} />
                <ListItemText primary="User Logs" />
              </ListItemButton>
            </List>
          </Collapse>

          <Divider sx={{ my: 1 }} />

          {/* Analytics */}
          <ListItemButton onClick={handleAnalyticsClick} sx={{ mb: 0.5 }}>
            <ListItemText
              primary="Analytics"
              primaryTypographyProps={{ fontWeight: 700, fontSize: 15 }}
            />
            {analyticsOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={analyticsOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "userAnalytics"}
                onClick={() => handleMenuSelect("userAnalytics")}
              >
                <BarChart sx={{ mr: 1 }} />
                <ListItemText primary="User Analytics" />
              </ListItemButton>

              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "filesAnalytics"}
                onClick={() => handleMenuSelect("filesAnalytics")}
              >
                <InsertDriveFile sx={{ mr: 1 }} />
                <ListItemText primary="Files Analytics" />
              </ListItemButton>
            </List>
          </Collapse>

          <Divider sx={{ my: 1 }} />

          {/* Model Management */}
          <ListItemButton onClick={handleModelMgmtClick} sx={{ mb: 0.5 }}>
            <ListItemText
              primary="Model Management"
              primaryTypographyProps={{ fontWeight: 700, fontSize: 15 }}
            />
            {modelMgmtOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={modelMgmtOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "model_dataset"}
                onClick={() => handleMenuSelect("model_dataset")}
              >
                <Storage sx={{ mr: 1 }} />
                <ListItemText primary="Datasets" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} selected={false}>
                <CloudUpload sx={{ mr: 1 }} />
                <ListItemText primary="Monitoring" />
              </ListItemButton>
            </List>
          </Collapse>

          <Divider sx={{ my: 1 }} />

          {/* File Management */}
          <ListItemButton onClick={handleFileMgmtClick} sx={{ mb: 0.5 }}>
            <ListItemText
              primary="File Management"
              primaryTypographyProps={{ fontWeight: 700, fontSize: 15 }}
            />
            {fileMgmtOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={fileMgmtOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "pendingSubmissions"}
                onClick={() => handleMenuSelect("pendingSubmissions")}
              >
                <Description sx={{ mr: 1 }} />
                <ListItemText primary="Pending Submissions" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                selected={selectedMenu === "approvedSubmissions"}
                onClick={() => handleMenuSelect("approvedSubmissions")}
              >
                <FolderOpen sx={{ mr: 1 }} />
                <ListItemText primary="Approved Submissions" />
              </ListItemButton>
            </List>
          </Collapse>
        </List>
      </Box>
    </Drawer>
  );
}
